@import "@/scss/use-bootstrap-mixins.scss";

.container {
  span.header_text {
    color: $primaryOnBackground !important;
    margin: 0 !important;
    font-size: calc(1.3rem + 0.6vw);
    font-weight: 600 !important;
  }

  span.subtitle {
    display: block;
    font-size: 12px;
    font-style: italic;
    p {
      margin: initial;
      max-width: initial;
    }
    a {
      color: #337ab7 !important;
    }
  }

  .bankName {
    font-size: 12px;
    font-weight: 500 !important;
    display: block;
    color: #444 !important;
  }

  .autobill_type {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
  }

  .directDebitDetails {
    display: flex;
    gap: 6px;
    flex-direction: column;

    @include media-breakpoint-up(md) {
      gap: 12px;
      flex-direction: row;
    }

    input {
      border: 1px solid #ccc;
      background-color: #fff !important;
      height: 41px !important;
      padding: 0 15px;
      font-size: 14px;
      border-radius: 4px;

      &:disabled {
        background-color: #f0f0f0;
        -webkit-animation: pulse 0.7s;
        -webkit-animation-iteration-count: 100;
        animation: pulse 0.7s;
        animation-iteration-count: 100;
      }

      &.invalid {
        border-color: #d04d52;
      }

      @-webkit-keyframes pulse {
        from {
          border-color: #d0d0d0;
        }
        50% {
          border-color: $primary;
        }
        to {
          border-color: #d0d0d0;
        }
      }
      @keyframes pulse {
        from {
          border-color: #d0d0d0;
        }
        50% {
          border-color: $primary;
        }
        to {
          border-color: #d0d0d0;
        }
      }
    }
  }

  .inputs {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 12px;

    @include media-breakpoint-up(lg) {
      max-width: 60%;
    }

    div {
      flex-basis: 100%;

      &:nth-of-type(1) {
        padding-bottom: 8px;
      }

      &:nth-of-type(2) {
        padding-bottom: 8px;
      }

      &:nth-of-type(3) {
        padding-right: 3px;
      }

      &:nth-of-type(4) {
        padding-left: 3px;
      }

      @include media-breakpoint-up(lg) {
        &:nth-of-type(1) {
          padding-right: 6px;
          padding-bottom: 6px;
        }

        &:nth-of-type(2) {
          padding-left: 6px;
          padding-bottom: 6px;
        }

        &:nth-of-type(3) {
          padding-right: 6px;
          padding-top: 6px;
        }

        &:nth-of-type(4) {
          padding-left: 6px;
          padding-top: 6px;
        }
      }

      .error_label {
        font-size: 12px;
        color: red !important;
        font-style: italic;
      }

      input {
        border: 1px solid #ccc;
        background-color: #fff !important;
        height: 41px !important;
        padding: 0 15px;
        font-size: 14px;
        border-radius: 4px;

        width: 100%;
      }

      @include media-breakpoint-up(lg) {
        flex-basis: 50%;
      }

      &:nth-of-type(3),
      &:nth-of-type(4) {
        flex-basis: 50%;
      }
    }
  }
}
